function mosquito(){
	return {
			"games":[
				{
					"informs":[
						{
							"text":"O Aedes aegypti é um mosquito natural do Egito, país que está localizado no Continente Africano.",
							"title":"Origem",
							"image":"/images/games/informs/mosquito/origem/1.jpg",
						},
						{
							"text":"Os exemplares desse mosquito vieram nos Navios Negreiros e começaram a se reproduzir no território brasileiro.",
							"title":"Origem",
							"image":"/images/games/informs/mosquito/origem/2.jpg",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/mosquito/origem/game.jpg"
				},
				{
					"informs":[
						{
							"text":"Os mosquitos se desenvolvem através de um ciclo de vida chamado metamorfose: compreendendo as fases de ovo -> larva -> pupa -> adulto",
							"title":"Ciclo De Vida",
							"image":"/images/games/informs/mosquito/ciclo_de_vida/1.jpg",
						},
						{
							"text":" Os ovos são depositados pela fêmea nas paredes de locais próximos à superfície da água, onde completam seu desenvolvimento embrionário. Também resistem longos períodos em lugares secos.",
							"title":"Ciclo De Vida",
							"image":"/images/games/informs/mosquito/ciclo_de_vida/2.jpg",
						},
						{
							"text":"A fase larvária é o período de alimentação e crescimento. As larvas alimentam-se de material orgânico acumulado nas paredes e no fundo dos locais onde estão.",
							"title":"Ciclo De Vida",
							"image":"/images/games/informs/mosquito/ciclo_de_vida/3.jpg",
						},
						{
							"text":"Na fase de pupa ocorre a metamorfose do estágio larval para o adulto (mosquito).",
							"title":"Ciclo De Vida",
							"image":"/images/games/informs/mosquito/ciclo_de_vida/4.jpg",
						},
						{
							"text":"A fase adulta do Aedes aegypti é a fase reprodutiva do inseto.  Milhares de insetos saem voando e irão se reproduzir em novas regiões.",
							"title":"Ciclo De Vida",
							"image":"/images/games/informs/mosquito/ciclo_de_vida/5.jpg",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/mosquito/ciclo_de_vida/game.jpg"
				},
				{
					"informs":[
						{
							"text":"Após a eclosão da pupa o mosquito permanece sobre as paredes do recipiente durante várias horas.",
							"title":"Nascimento e Crescimento",
							"image":"/images/games/informs/mosquito/nascimento_e_crescimento/1.jpg",
						},
						{
							"text":"Isto permite o endurecimento do exoesqueleto, das asas e, no caso dos machos, a rotação da genitália em 180°.",
							"title":"Nascimento e Crescimento",
							"image":"/images/games/informs/mosquito/nascimento_e_crescimento/2.jpg",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/mosquito/nascimento_e_crescimento/game.jpg"
				},
				{
					"informs":[
						{
							"text":"Dentro de 24 horas após emergirem, os mosquitos já estão aptos para o acasalamento que geralmente ocorre durante o voo, mas, ocasionalmente, pode se dar sobre uma superfície.",
							"title":"Reprodução",
							"image":"/images/games/informs/mosquito/reproducao/1.jpg",
						},
						{
							"text":"Uma única inseminação é suficiente para fecundar todos os ovulos que a fêmea venha a produzir durante sua vida. Após fecundação os óvulos são chamados de ovos.",
							"title":"Reprodução",
							"image":"/images/games/informs/mosquito/reproducao/1.jpg",
						},
						{
							"text":"Tanto o macho quanto a fêmea se alimentam de substâncias que contêm açúcar (néctar, seiva, entre outros), mas a fêmea precisa de sangue para a  produção dos óvulos e, após fecundação, desenvolvimento dos ovos, assim somente a fêmea pica os animais.",
							"title":"Reprodução",
							"image":"/images/games/informs/mosquito/reproducao/2.jpg",
						},
						{
							"text":"Se picar uma pessoa contaminada com o vírus da dengue, chikungunya, zika ou febre amarela passa a transportar o vírus durante toda a sua vida  e transmiti-lo para outras pessoas que picar.",
							"title":"Reprodução",
							"image":"/images/games/informs/mosquito/reproducao/2.jpg",
						},
						{
							"text":" A fêmeas preferem água limpa e cristalina para depositar os ovos ao invés de água suja ou poluída por matéria orgânica.",
							"title":"Reprodução",
							"image":"/images/games/informs/mosquito/reproducao/3.jpg",
						},
						{
							"text":"A deposição dos ovos se dá mais frequentemente no fim da tarde. A fêmea grávida deposita os ovos em recipientes escuros ou sombreados com superfícies ásperas.",
							"title":"Reprodução",
							"image":"/images/games/informs/mosquito/reproducao/4.jpg",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/mosquito/reproducao/game.jpg"
				},
				{
					"informs":[
						{
							"text":"Os adultos de Aedes aegypti podem permanecer vivos em laboratório durante meses, mas, na natureza, vivem em média de 30 a 35 dias.",
							"title":"Morte",
							"image":"/images/games/informs/mosquito/morte/1.jpg",
						},
						{
							"text":"Com uma mortalidade diária de 10%, a metade dos mosquitos morrem durante a primeira semana de vida e 95% durante o primeiro mês.",
							"title":"Morte",
							"image":"/images/games/informs/mosquito/morte/2.jpg",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/mosquito/morte/game.jpg"
				}
			]
		};
}

export {mosquito};
